<app-feature-tiles-grid
  id="installation-panels"
  *ngIf="installationDetailsStore.getSelectedGateway$ | async as gateway"
  cdkDropListGroup
>
  <ng-container *ngFor="let panel of panels; trackBy: trackBy">
    <ng-container [ngSwitch]="panel.panel">
      <!-- Notification Tile -->
      <ng-container *ngSwitchCase="panelTypes.NotificationTile">
        <div
          *ngIf="(gatewayStatus$ | async)?.offline && (devicesStore.isCommonDevice$ | async)"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.NotificationTile"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-notification-tile
          >
            <app-notification-tile
              data-at-tile="notification"
              [lastStatusChanged]="gateway?.lastStatusChangedAt"
            ></app-notification-tile>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- System Panel -->
      <ng-container *ngSwitchCase="panelTypes.System">
        <div
          *ngIf="
            (isSystemPanelVisible$ | async) &&
            (devicesStore.isCommonDevice$ | async) &&
            (installationDetailsStore.selectGatewayHasDevices(gatewaySerial) | async)
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.System"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-system-panel-tile
          >
            <app-system data-at-tile="system"></app-system>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Communication module -->
      <ng-container *ngSwitchCase="panelTypes.CommunicationModule">
        <div
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.CommunicationModule"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-communication-module-tile
          >
            <app-gateway-features-panel
              data-at-tile="gateway"
              [gatewaySerial]="gateway?.serial"
              [installationId]="installationId"
              [isLegacyDevice]="isLegacyDevice"
            ></app-gateway-features-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Single Room Control -->
      <ng-container *ngSwitchCase="panelTypes.SingleRoomControl">
        <ng-container *ngIf="rooms$ | async | ready as feature">
          <div
            *ngIf="
              !(isVicareThermostatMode$ | async) &&
              feature &&
              (devicesStore.isCommonDevice$ | async)
            "
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerialOfSelectedDevice"
              [panel]="panelTypes.SingleRoomControl"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              [attr.data-feature]="feature.feature"
              data-at-default-src-tile
            >
              <app-single-room-control
                data-at-tile="src"
                [installationId]="installationId"
                [deviceSelectId]="deviceSelectId"
                [deviceId]="deviceId"
                [gatewaySerial]="gatewaySerial"
              >
              </app-single-room-control>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- DHW Panel -->
      <ng-container *ngSwitchCase="panelTypes.Dhw">
        <div
          *ngIf="dhw$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.Dhw"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-dhw-tile
          >
            <app-warm-water
              data-at-tile="dhw"
              [deviceSelectId]="deviceSelectId"
              [deviceId]="deviceId"
            ></app-warm-water>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Buffer Tank Panel -->
      <ng-container *ngSwitchCase="panelTypes.BufferTank">
        <div
          *ngIf="bufferTank$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.BufferTank"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-buffer-tank-tile
          >
            <app-buffer-tank data-at-tile="buffer-tank" [deviceId]="deviceId"></app-buffer-tank>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Gas Consumption -->
      <ng-container *ngSwitchCase="panelTypes.GasConsumption">
        <ng-container
          *ngIf="
            !(
              isCascadeInstallation &&
              (installationDetailsStore.isInstallationVitocrossalNAType$ | async)
            )
          "
        >
          <div
            *ngIf="gasConsumptionChartData$ | async as chartData"
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerialOfSelectedDevice"
              [panel]="panelTypes.GasConsumption"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-default-gas-consumption-tile
            >
              <app-generic-consumption-chart-panel
                data-at-tile="gas-consumption"
                [title]="'+INSTALLATIONS.INSTALLATION.GAS_CONSUMPTION'"
                [deviceSelectId]="deviceSelectId"
                [chartData]="chartData"
                [overlayType]="availableOverlays.GasConsumption"
                [tooltipInfo]="tooltipInfo"
              ></app-generic-consumption-chart-panel>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Summary Gas Consumption -->
      <ng-container *ngSwitchCase="panelTypes.SummaryGasConsumption">
        <ng-container *ngIf="!(gasConsumptionHeating$ | async)">
          <ng-container
            *ngrxLet="gasConsumptionSummaryHeating$ | async | ready as gasConsumptionSummaryHeating"
          >
            <ng-container
              *ngrxLet="gasConsumptionSummaryDhw$ | async | ready as gasConsumptionSummaryDhw"
            >
              <div
                *ngIf="gasConsumptionSummaryHeating || gasConsumptionSummaryDhw"
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="gatewaySerialOfSelectedDevice"
                  [panel]="panelTypes.SummaryGasConsumption"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-default-summary-gas-consumption-tile
                >
                  <app-generic-consumption-panel
                    data-at-tile="summary-gas-consumption"
                    [title]="'+INSTALLATIONS.INSTALLATION.SUMMARY_GAS_CONSUMPTION'"
                    [deviceSelectId]="deviceSelectId"
                    [gasConsumptionSummaryHeating]="gasConsumptionSummaryHeating"
                    [gasConsumptionSummaryDhw]="gasConsumptionSummaryDhw"
                    [overlayType]="availableOverlays.SummaryGasConsumption"
                  ></app-generic-consumption-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Summary Power Consumption -->
      <ng-container *ngSwitchCase="panelTypes.SummaryElectricityConsumption">
        <ng-container *ngIf="!(powerConsumptionHeating$ | async)">
          <ng-container
            *ngrxLet="
              powerConsumptionSummaryHeating$ | async | ready as powerConsumptionSummaryHeating
            "
          >
            <ng-container
              *ngrxLet="powerConsumptionSummaryDhw$ | async | ready as powerConsumptionSummaryDhw"
            >
              <div
                *ngIf="powerConsumptionSummaryHeating || powerConsumptionSummaryDhw"
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="gatewaySerialOfSelectedDevice"
                  [panel]="panelTypes.SummaryElectricityConsumption"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-default-summary-electricity-consumption-tile
                >
                  <app-generic-consumption-panel
                    data-at-tile="summary-electricity-consumption"
                    [title]="'+INSTALLATIONS.INSTALLATION.SUMMARY_ELECTRICITY_CONSUMPTION'"
                    [deviceSelectId]="deviceSelectId"
                    [powerConsumptionSummaryHeating]="powerConsumptionSummaryHeating"
                    [powerConsumptionSummaryDhw]="powerConsumptionSummaryDhw"
                    [overlayType]="availableOverlays.SummaryElectricityConsumption"
                  ></app-generic-consumption-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Summary Autarky -->
      <ng-container *ngSwitchCase="panelTypes.Autarky">
        <div
          *ngIf="autarkySummary$ | async | ready as autarkySummary"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.Autarky"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-autarky-tile
          >
            <app-generic-consumption-panel
              data-at-tile="summary-autarky"
              [title]="'+INSTALLATIONS.INSTALLATION.AUTARKY'"
              [deviceSelectId]="deviceSelectId"
              [autarkySummary]="autarkySummary"
              [overlayType]="availableOverlays.Autarky"
            ></app-generic-consumption-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Power Production -->
      <ng-container *ngSwitchCase="panelTypes.PowerProduction">
        <div
          *ngIf="powerProductionChartData$ | async as chartData"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.PowerProduction"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-power-production-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="power-production"
              [title]="'+INSTALLATIONS.INSTALLATION.POWER_PRODUCTION'"
              [deviceSelectId]="deviceSelectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.PowerProduction"
              [tooltipInfo]="tooltipInfo"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Heat Production -->
      <ng-container *ngSwitchCase="panelTypes.HeatProduction">
        <div
          *ngIf="heatProductionChartData$ | async as chartData"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.HeatProduction"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-heat-production-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="heat-production"
              [title]="'+INSTALLATIONS.INSTALLATION.HEAT_PRODUCTION'"
              [deviceSelectId]="deviceSelectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.HeatProduction"
              [tooltipInfo]="tooltipInfo"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Solar Power Production -->
      <ng-container *ngSwitchCase="panelTypes.SolarPowerProduction">
        <div
          *ngIf="solarPowerProductionChartData$ | async as chartData"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.SolarPowerProduction"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-solar-power-production-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="solar-power-production"
              [title]="'+INSTALLATIONS.INSTALLATION.SOLAR_POWER_PRODUCTION'"
              [deviceSelectId]="deviceSelectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.SolarPowerProduction"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Electricity Consumption -->
      <ng-container *ngSwitchCase="panelTypes.ElectricConsumption">
        <div
          *ngIf="
            !(devicesStore.isEcotronicDevice$ | async) &&
            (electricityConsumptionChartData$ | async) as chartData
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.ElectricConsumption"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-electric-consumption-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="electric-consumption"
              [title]="'+INSTALLATIONS.INSTALLATION.POWER_CONSUMPTION'"
              [deviceSelectId]="deviceSelectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.ElectricityConsumption"
              [tooltipInfo]="tooltipInfo"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Fuel Consumption -->
      <ng-container *ngSwitchCase="panelTypes.FuelConsumption">
        <div
          *ngIf="
            (devicesStore.isEcotronicDevice$ | async) &&
            (electricityConsumptionChartData$ | async) as chartData
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.FuelConsumption"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-fuel-consumption-tile
          >
            <app-generic-consumption-chart-panel
              data-at-tile="fuel-consumption"
              [title]="'+INSTALLATIONS.INSTALLATION.FUEL_CONSUMPTION'"
              [deviceSelectId]="deviceSelectId"
              [chartData]="chartData"
              [overlayType]="availableOverlays.FuelConsumption"
              [tooltipInfo]="tooltipInfo"
            ></app-generic-consumption-chart-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Energy Cockpit -->
      <ng-container *ngSwitchCase="panelTypes.EnergyCockpit">
        <div
          *ngIf="powerCumulativeProducedFeature$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.EnergyCockpit"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-energy-cockpit-tile
          >
            <app-energy-cockpit-panel
              data-at-tile="energy-cockpit"
              [deviceSelectId]="deviceSelectId"
              [deviceId]="deviceId"
            ></app-energy-cockpit-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Solar Panel -->
      <ng-container *ngSwitchCase="panelTypes.Solar">
        <div
          *ngIf="solar$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.Solar"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-solar-tile
          >
            <app-solar
              data-at-tile="solar"
              [deviceSelectId]="deviceSelectId"
              [deviceId]="deviceId"
            ></app-solar>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Fuel Cell Panel -->
      <ng-container *ngSwitchCase="panelTypes.FuelCell">
        <div
          *ngIf="(devicesStore.isFuelCellDevice$ | async) && !(gatewayStatus$ | async)?.offline"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.FuelCell"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-fuel-cell-tile
          >
            <app-fuel-cell
              data-at-tile="fuel-cell"
              [deviceSelectId]="deviceSelectId"
              [deviceId]="deviceId"
            ></app-fuel-cell>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Heating Zone/Circuits -->
      <ng-container *ngIf="availableCircuitsDetails$ | async as availableCircuits">
        <ng-container *ngFor="let circuit of availableCircuits">
          <ng-container
            *ngIf="
              circuit?.feature?.properties?.type?.value !== circuitType.HeatingCircuit;
              then TTCircuit;
              else heatingCircuit
            "
          ></ng-container>

          <ng-template #TTCircuit>
            <ng-container *ngSwitchCase="getTTCircuitPanelName(circuit.circuitId)">
              <div
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="gatewaySerialOfSelectedDevice"
                  [panel]="getTTCircuitPanelName(circuit.circuitId)"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-default-circuit-heating-zone-tile
                >
                  <app-circuit-heating-zone-features-panel
                    data-at-tile="circuit-heating-zone"
                    [circuitId]="circuit.circuitId"
                    [deviceSelectId]="deviceSelectId"
                    [deviceId]="deviceId"
                    [header]="installationService.getCircuitName(circuit.circuitId) | async"
                  >
                  </app-circuit-heating-zone-features-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-template>

          <ng-template #heatingCircuit>
            <ng-container *ngSwitchCase="getHeatingCircuitPanelName(circuit.circuitId)">
              <div
                cdkDropList
                cdkDropListOrientation="horizontal"
                [cdkDropListData]="panel.panel"
                (cdkDropListDropped)="drop($event)"
              >
                <app-installation-ordered-element
                  [orderKey]="gatewaySerialOfSelectedDevice"
                  [panel]="getHeatingCircuitPanelName(circuit.circuitId)"
                  cdkDrag
                  [cdkDragDisabled]="isDragDropDisabled"
                  data-at-default-heating-circuit-tile
                >
                  <app-heating-circuit-features-panel
                    data-at-tile="heating-circuit"
                    [circuitId]="circuit.circuitId"
                    [deviceSelectId]="deviceSelectId"
                    [deviceId]="deviceId"
                    [header]="installationService.getCircuitName(circuit.circuitId) | async"
                    [attr.data-at-tile]="'heatingCircuit' + circuit.circuitId"
                  ></app-heating-circuit-features-panel>
                </app-installation-ordered-element>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="devicesStore.isHeatingZoneAvailable$ | async">
        <ng-container
          *ngIf="
            devicesStore.getCallForHeatHeatingZoneIndex(deviceSelectId)
              | async as callForHeatHeatingZoneIndex
          "
        >
          <ng-container *ngIf="panel.panel === getCallForHeatHeatingZonePanelName()">
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="panel.panel"
              (cdkDropListDropped)="drop($event)"
              data-at-default-call-for-heat-heating-zone-tile
            >
              <app-installation-ordered-element
                [orderKey]="gatewaySerialOfSelectedDevice"
                [panel]="getCallForHeatHeatingZonePanelName()"
                cdkDrag
                [cdkDragDisabled]="isDragDropDisabled"
              >
                <app-call-for-heat-heating-zone-features-panel
                  data-at-tile="call-for-heat-heating-zone"
                  [deviceSelectId]="deviceSelectId"
                  [deviceId]="deviceId"
                  [header]="
                    installationService.getCallForHeatHeatingZoneName(
                      callForHeatHeatingZoneIndex.index
                    )
                  "
                >
                </app-call-for-heat-heating-zone-features-panel>
              </app-installation-ordered-element>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Ventilation -->
      <ng-container *ngSwitchCase="panelTypes.Ventilation">
        <ng-container
          *ngIf="!(isVitopureDevice$ | async) && (ventilationMode$ | async | ready) as mode"
        >
          <ng-container *ngIf="ventilationProgram$ | async | ready as program">
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="panel.panel"
              (cdkDropListDropped)="drop($event)"
            >
              <app-installation-ordered-element
                [orderKey]="gatewaySerialOfSelectedDevice"
                [panel]="panelTypes.Ventilation"
                cdkDrag
                [cdkDragDisabled]="isDragDropDisabled"
                [attr.data-feature]="program.feature + ' || ' + mode.feature"
                data-at-default-ventilation-tile
              >
                <app-ventilation
                  data-at-tile="ventilation"
                  [deviceSelectId]="deviceSelectId"
                  [deviceId]="deviceId"
                ></app-ventilation>
              </app-installation-ordered-element>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- ESS System -->
      <ng-container *ngSwitchCase="panelTypes.Battery">
        <div
          *ngIf="
            (devicesStore.isESSDevice$ | async) &&
            (gatewayStatus$ | async)?.online &&
            (isEssBatteryOrHybrid$ | async)
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.Battery"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-battery-tile
          >
            <app-battery
              data-at-tile="battery"
              [deviceSelectId]="deviceSelectId"
              [deviceId]="deviceId"
            ></app-battery>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Photovoltaics -->
      <ng-container *ngSwitchCase="panelTypes.Photovoltaics">
        <div
          *ngIf="photovoltaicCumulatedEnergy$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.Photovoltaics"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-photovoltaics-tile
          >
            <app-photovoltaics
              data-at-tile="photovoltaics"
              [deviceSelectId]="deviceSelectId"
              [deviceId]="deviceId"
            ></app-photovoltaics>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Electric heater -->
      <ng-container *ngIf="electricHeater$ | async | ready as feature">
        <ng-container *ngSwitchCase="panelTypes.ElectricHeater">
          <div
            *ngIf="feature?.properties?.enabled?.value?.length > 0"
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerialOfSelectedDevice"
              [panel]="panelTypes.ElectricHeater"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              [attr.data-feature]="feature.feature"
              data-at-default-electric-heater-tile
            >
              <app-electric-heater
                data-at-tile="electric-heater"
                [device]="device"
                [heatingRodIndex]="
                  device
                    | electricHeaterSelectHeatingRodIndex
                      : (electricHeaterService.aggregatedHeatingRodsIndexesWithBoilerSerials()
                          | async)
                "
              ></app-electric-heater>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- Ecowater Panel -->
      <ng-container *ngSwitchCase="panelTypes.EcoWater">
        <div
          *ngIf="saltLevelDays$ | async | ready as feature"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.EcoWater"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            [attr.data-feature]="feature.feature"
            data-at-default-eco-water-tile
          >
            <app-eco-water data-at-tile="eco-water"></app-eco-water>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Refrigerant Circuit -->
      <ng-container
        *ngIf="enabledRefrigerantCircuits$ | async | ready | featureValue: 'enabled' as circuitIds"
      >
        <ng-container *ngFor="let refrigerantCircuitId of circuitIds">
          <ng-container
            *ngIf="panel.panel === panelTypes['RefrigerantCircuit' + refrigerantCircuitId]"
          >
            <div
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="panel.panel"
              (cdkDropListDropped)="drop($event)"
            >
              <app-installation-ordered-element
                [orderKey]="gatewaySerialOfSelectedDevice"
                [panel]="panelTypes['RefrigerantCircuit' + refrigerantCircuitId]"
                cdkDrag
                [cdkDragDisabled]="isDragDropDisabled"
                [attr.data-feature]="circuitIds.feature"
                data-at-default-refrigerant-circuit-tile
              >
                <app-refrigerant-circuit-features-panel
                  [attr.data-at-tile]="'refrigerantCircuit'"
                  [deviceSelectId]="deviceSelectId"
                  [deviceId]="deviceId"
                  [refrigerantCircuitId]="refrigerantCircuitId"
                  [header]="installationService.getRefrigerantCircuitName(refrigerantCircuitId)"
                ></app-refrigerant-circuit-features-panel>
              </app-installation-ordered-element>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- ViCare plans -->
      <ng-container *ngSwitchCase="panelTypes.ViCarePlans">
        <ng-container
          *ngIf="
            (installationDetailsStore.isViCarePlansVisible$ | async) &&
            (devicesStore.isCommonDevice$ | async)
          "
        >
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerialOfSelectedDevice"
              [panel]="panelTypes.ViCarePlans"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-default-vicare-plans-tile
            >
              <app-vicare-plans data-at-tile="vicare-plans"></app-vicare-plans>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!-- ViCare thermostat -->
      <ng-container *ngSwitchCase="panelTypes.ViCareThermostat">
        <ng-container *ngIf="isVicareThermostatMode$ | async">
          <div
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListData]="panel.panel"
            (cdkDropListDropped)="drop($event)"
          >
            <app-installation-ordered-element
              [orderKey]="gatewaySerialOfSelectedDevice"
              [panel]="panelTypes.ViCareThermostat"
              cdkDrag
              [cdkDragDisabled]="isDragDropDisabled"
              data-at-default-vicare-thermostat-tile
            >
              <app-vicare-thermostat data-at-tile="vicare-thermostat"></app-vicare-thermostat>
            </app-installation-ordered-element>
          </div>
        </ng-container>
      </ng-container>

      <!--Internal Hydraulic-->
      <ng-container *ngSwitchCase="panelTypes.InternalHydraulic">
        <div
          *ngIf="
            (devicesStore.isE3HeatpumpDevice() | async) &&
            (devicesStore.isInternalHydraulicAvailable(deviceId) | async)
          "
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.InternalHydraulic"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-internalHydraulic-tile
          >
            <app-internal-hydraulic-features-panel
              data-at-tile="internalHydraulic"
              [deviceId]="deviceId"
            ></app-internal-hydraulic-features-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>

      <!-- Hybrid Pro Control Panel -->
      <ng-container *ngSwitchCase="panelTypes.HybridProControl">
        <div
          *ngIf="installationFeaturesStore.iselectIsHybridProTileVisible(deviceId) | async"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="panel.panel"
          (cdkDropListDropped)="drop($event)"
        >
          <app-installation-ordered-element
            [orderKey]="gatewaySerialOfSelectedDevice"
            [panel]="panelTypes.HybridProControl"
            cdkDrag
            [cdkDragDisabled]="isDragDropDisabled"
            data-at-default-hybridProControl-tile
          >
            <app-hybrid-pro-panel data-at-tile="hybridProControl"></app-hybrid-pro-panel>
          </app-installation-ordered-element>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</app-feature-tiles-grid>
